export default class SmartHomeOwnController {
  constructor(updEnvironment, updStore, $element, $scope) {
    'ngInject';

    //to do: ES6 assignment
    Object.assign(this, {
      updEnvironment,
      updStore,
      $element,
      $scope,
    });
  }

  $onInit() {
    import(/* webpackChunkName: "smart-home-own" */ './app').then(
      async ({ smartHomeOwnApp }) => {
        const appElement = this.$element[0].querySelector(
          '#upd-smart-home-own-app'
        );

        const { destroy } = smartHomeOwnApp(appElement, {
          basePath: '/smart-home',
          env: this.updEnvironment,
          updStore: this.updStore,
        });

        this.$scope.$on('$destroy', destroy);
      }
    );
  }
}
